import { defineMessages } from 'react-intl';

const scope = 'app.widgets.Widget';

export default defineMessages({
    error: {
        id: `${scope}.error`,
        defaultMessage: "We're having issues retrieving your data. Please try again later.",
    },
    retry: {
        id: `${scope}.error.retryBtn.label`,
        defaultMessage: 'Retry',
    },
    betaLabel: {
        id: `${scope}.beta.label`,
        defaultMessage: 'BETA',
    },
    betaTooltip: {
        id: `${scope}.beta.tooltip.message`,
        defaultMessage:
            'This report is in early stages of development and we would appreciate your feedback - Thank you.',
    },
});
